/**
 * Cart configuration for the Shimmybooks marketplace.
 *
 * Container sizing is not here: it is derived from what is in the basket by
 * `src/util/shippingModel.js`, which the server loads too. The count-based
 * escalation rules that used to live here priced by how many books there were
 * rather than how big they are, and disagreed with the single-item path.
 */

export const CART_CONFIG = {
  // Maximum number of books a buyer can add per seller in one cart checkout.
  //
  // No longer a shipping constraint — a basket that needs more than one parcel
  // gets more than one parcel (SHIPPING_PRICING.md §A2). This is only a sanity
  // limit so a basket can't demand an absurd number of containers.
  maxItemsPerSeller: 8,
};

/**
 * Get the total item count for a single seller's cart,
 * excluding non-listing keys like 'deliveryMethod'.
 *
 * @param {Object} sellerCart - One seller's cart object { listingId: {count}, deliveryMethod: '...' }
 * @returns {number} Total item count
 */
export const getCartItemCount = sellerCart => {
  if (!sellerCart) return 0;
  return Object.keys(sellerCart).reduce((sum, key) => {
    if (key === 'deliveryMethod') return sum;
    const entry = sellerCart[key];
    return sum + (entry && typeof entry.count === 'number' ? entry.count : 0);
  }, 0);
};

/**
 * Get listing IDs from a single seller's cart, filtering out metadata keys.
 *
 * @param {Object} sellerCart - One seller's cart object
 * @returns {string[]} Array of listing ID strings
 */
export const getSellerCartListingIds = sellerCart => {
  if (!sellerCart) return [];
  return Object.keys(sellerCart).filter(key => key !== 'deliveryMethod');
};
